// @flow
import * as React from 'react';
import { FeatureBanner } from 'components';
import networkIcon from './network-icon.png';

const SyndicationCopy = () => (
  <FeatureBanner
    heading="Syndication enables UGC sharing from brands to retailers"
    copy="On average, Syndication provides 58% of retailer’s reviews, leading to
higher impression and conversion rates on product pages."
    iconUrl={networkIcon}
  />
);

export default SyndicationCopy;



// WEBPACK FOOTER //
// ./src/containers/search/NetworkSearchCopy.js